// 配布物の UMD ラッパーを ES モジュール形式に置き換えている（本体は配布物のまま）。
// Vite の開発サーバーはこのファイルを変換せずに ES モジュールとして配信するため。

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = it.call(o);
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var Store = /*#__PURE__*/function () {
    function Store() {
      var _options$_daysExpirat, _options$schemaVersio;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Store);

      _defineProperty(this, "_listeners", []);

      this._categories = options.categories || [];
      this._acceptedState = options.acceptedState || "granted";
      this._deniedState = options.deniedState || "denied";
      this._daysExpiration = (_options$_daysExpirat = options._daysExpiration) !== null && _options$_daysExpirat !== void 0 ? _options$_daysExpirat : 30;
      var schemaVersion = (_options$schemaVersio = options.schemaVersion) !== null && _options$schemaVersio !== void 0 ? _options$schemaVersio : 1;

      try {
        var jsonOrNull = localStorage.getItem("cookie-consent-state");
        this._state = jsonOrNull ? JSON.parse(jsonOrNull) : null;

        if (this._state && this._state.schemaVersion != schemaVersion) {
          this._state = null;
        }
      } catch (error) {}

      this._state = this._state || {
        categories: {},
        schemaVersion: schemaVersion
      };
    }

    _createClass(Store, [{
      key: "addListener",
      value: function addListener(listener) {
        this._listeners.push(listener);
      }
    }, {
      key: "acceptAll",
      value: function acceptAll() {
        var consentParams = {};

        var _iterator = _createForOfIteratorHelper(this._categories),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var category = _step.value;
            consentParams[category] = this._acceptedState;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.update(consentParams);
      }
    }, {
      key: "denyAll",
      value: function denyAll() {
        var consentParams = {};

        var _iterator2 = _createForOfIteratorHelper(this._categories),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var category = _step2.value;
            consentParams[category] = this._deniedState;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        this.update(consentParams);
      }
    }, {
      key: "update",
      value: function update(consentParams) {
        var prevConsentState = this.currentConsentState();

        for (var key in consentParams) {
          this._state.categories[key] = {
            state: consentParams[key],
            expiresAt: consentParams[key] == this._acceptedState ? null : this._expiresAt().toISOString()
          };
        }

        try {
          localStorage.setItem("cookie-consent-state", JSON.stringify(this._state));
        } catch (error) {}

        var currentConsentState = this.currentConsentState();
        var consentStateChanged = false;

        for (var key in currentConsentState) {
          if (prevConsentState[key] != currentConsentState[key]) {
            consentStateChanged = true;
          }
        }

        var _iterator3 = _createForOfIteratorHelper(this._listeners),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var l = _step3.value;
            if (l.onUpdate) l.onUpdate(this, consentStateChanged);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "isAccepted",
      value: function isAccepted(categoryOrCategories) {
        var _this = this;

        var categories = Array.isArray(categoryOrCategories) ? categoryOrCategories : [categoryOrCategories];
        return categories.every(function (category) {
          var consentCategory = _this._state.categories[category];
          return consentCategory && consentCategory.state == _this._acceptedState;
        });
      }
    }, {
      key: "acceptedCategories",
      value: function acceptedCategories() {
        var categories = [];

        for (var category in this._state.categories) {
          if (this._state.categories[category].state == this._acceptedState) {
            categories.push(category);
          }
        }

        return categories;
      }
    }, {
      key: "needNotice",
      value: function needNotice() {
        var _this2 = this;

        return this._categories.some(function (category) {
          var consentCategory = _this2._state.categories[category];
          if (!consentCategory) return true;
          return consentCategory.state != _this2._acceptedState && consentCategory.expiresAt < new Date().toISOString();
        });
      }
    }, {
      key: "hasConsentState",
      value: function hasConsentState() {
        return 0 < Object.keys(this._state.categories).length;
      }
    }, {
      key: "currentConsentState",
      value: function currentConsentState() {
        var result = {};

        var _iterator4 = _createForOfIteratorHelper(this._categories),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var categoty = _step4.value;
            var consentCategory = this._state.categories[categoty];
            result[categoty] = consentCategory && consentCategory.state == this._acceptedState ? this._acceptedState : this._deniedState;
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        return result;
      }
    }, {
      key: "_expiresAt",
      value: function _expiresAt() {
        var d = new Date();
        d.setDate(d.getDate() + this._daysExpiration);
        return d;
      }
    }]);

    return Store;
  }();

  var Util = /*#__PURE__*/function () {
    function Util() {
      _classCallCheck(this, Util);
    }

    _createClass(Util, null, [{
      key: "buildHTML",
      value: function buildHTML(html) {
        var el = document.createElement('div');
        el.innerHTML = html;
        var result = el.children[0];
        el.removeChild(result);
        return result;
      }
    }]);

    return Util;
  }();

  var Banner = /*#__PURE__*/function () {
    function Banner() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Banner);

      _defineProperty(this, "_listeners", []);

      _defineProperty(this, "_showingContainer", null);

      this._options = options;
    }

    _createClass(Banner, [{
      key: "addListener",
      value: function addListener(listener) {
        this._listeners.push(listener);
      }
    }, {
      key: "show",
      value: function show() {
        var _this = this;

        if (this._showingContainer) {
          return;
        }

        var container = Util.buildHTML("\n<div class=\"cc--banner\">\n  <div class=\"cc--banner-content\">\n    <p class=\"cc--banner-description\"></p>\n    <div class=\"cc--banner-buttons\">\n      <a class=\"cc--banner-settings\"></a>\n      <a class=\"cc--banner-deny\"></a>\n      <a class=\"cc--banner-accept\"></a>\n    </div>\n  </div>\n</div>");
        container.querySelector(".cc--banner-description").innerHTML = this._options.description;

        if (this._options.labels.settings) {
          container.querySelector(".cc--banner-settings").innerText = this._options.labels.settings;
          container.querySelector(".cc--banner-settings").addEventListener("click", function (e) {
            e.preventDefault();

            var _iterator = _createForOfIteratorHelper(_this._listeners),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var l = _step.value;
                if (l.onSettings) l.onSettings();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }, false);
        } else {
          container.querySelector(".cc--banner-settings").style.display = "none";
        }

        if (this._options.labels.deny) {
          container.querySelector(".cc--banner-deny").innerText = this._options.labels.deny;
          container.querySelector(".cc--banner-deny").addEventListener("click", function (e) {
            e.preventDefault();

            var _iterator2 = _createForOfIteratorHelper(_this._listeners),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var l = _step2.value;
                if (l.onDeny) l.onDeny();
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }, false);
        } else {
          container.querySelector(".cc--banner-deny").style.display = "none";
        }

        container.querySelector(".cc--banner-accept").innerText = this._options.labels.accept;
        container.querySelector(".cc--banner-accept").addEventListener("click", function (e) {
          e.preventDefault();

          var _iterator3 = _createForOfIteratorHelper(_this._listeners),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var l = _step3.value;
              if (l.onAccept) l.onAccept();
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }, false);
        document.body.appendChild(container);
        document.body.classList.add("cc--banner-shown");
        this._showingContainer = container;

        var _iterator4 = _createForOfIteratorHelper(this._listeners),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var l = _step4.value;
            if (l.onShow) l.onShow();
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }, {
      key: "hide",
      value: function hide() {
        if (this._showingContainer) {
          document.body.removeChild(this._showingContainer);
          document.body.classList.remove("cc--banner-shown");
          this._showingContainer = null;

          var _iterator5 = _createForOfIteratorHelper(this._listeners),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var l = _step5.value;
              if (l.onShow) l.onHide();
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }
    }]);

    return Banner;
  }();

  var Dialog = /*#__PURE__*/function () {
    function Dialog() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Dialog);

      _defineProperty(this, "_listeners", []);

      _defineProperty(this, "_showingContainer", null);

      this._options = options;
      this._acceptedState = options.acceptedState || "granted";
      this._deniedState = options.deniedState || "denied";
    }

    _createClass(Dialog, [{
      key: "addListener",
      value: function addListener(listener) {
        this._listeners.push(listener);
      }
    }, {
      key: "show",
      value: function show(acceptedCategories) {
        var _this = this;

        if (this._showingContainer) {
          return;
        }

        var container = Util.buildHTML("\n<div class=\"cc--dialog\">\n  <div class=\"cc--dialog-content\">\n    <div class=\"cc--dialog-header\">\n      <span class=\"cc--dialog-title\"></span>\n      <a class=\"cc--dialog-close-button\"></a>\n    </div>\n    <div class=\"cc--dialog-body\">\n      <ul class=\"cc--dialog-consent-item-list\"></ul>\n    </div>\n    <div class=\"cc--dialog-footer\">\n      <a class=\"cc--dialog-save-all-button\"></a>\n      <a class=\"cc--dialog-save-button\"></a>\n    </div>\n  </div>\n</div>");
        container.querySelector(".cc--dialog-title").innerText = this._options.labels.title;
        container.querySelector(".cc--dialog-close-button").innerText = this._options.labels.closeButton;
        container.querySelector(".cc--dialog-close-button").addEventListener("click", function (e) {
          e.preventDefault();

          _this.hide();
        }, false);
        var itemList = container.querySelector(".cc--dialog-consent-item-list");

        if (this._options.necessaryItem) {
          var item = Util.buildHTML("\n<li>\n  <div>\n    <input type=\"checkbox\" checked=\"checked\" disabled=\"disabled\" id=\"cc--necessary\">\n    <label></label>\n  </div>\n  <p></p>\n</li>");
          item.querySelector("label").setAttribute("for", "cc--necessary");
          item.querySelector("label").innerText = this._options.necessaryItem.title;
          item.querySelector("p").innerText = this._options.necessaryItem.description;
          itemList.appendChild(item);
        }

        var checkByCategory = {};

        var _iterator = _createForOfIteratorHelper(this._options.consentItems),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var consentItem = _step.value;

            var _item = Util.buildHTML("\n<li>\n  <div>\n    <input type=\"checkbox\">\n    <label></label>\n  </div>\n  <p></p>\n</li>");

            var check = _item.querySelector("input[type=checkbox]");

            check.setAttribute("id", "cc" + consentItem.category);

            if (acceptedCategories.indexOf(consentItem.category) != -1) {
              check.setAttribute("checked", "checked");
            }

            checkByCategory[consentItem.category] = check;

            _item.querySelector("label").setAttribute("for", "cc" + consentItem.category);

            _item.querySelector("label").innerText = consentItem.title;
            _item.querySelector("p").innerText = consentItem.description;
            itemList.appendChild(_item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        container.querySelector(".cc--dialog-save-all-button").innerText = this._options.labels.saveAllButton;
        container.querySelector(".cc--dialog-save-all-button").addEventListener("click", function (e) {
          e.preventDefault();
          var consentItems = {};

          for (var category in checkByCategory) {
            consentItems[category] = _this._acceptedState;
          }

          var _iterator2 = _createForOfIteratorHelper(_this._listeners),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var l = _step2.value;

              if (l.onSave) {
                l.onSave(consentItems);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          _this.hide();
        }, false);
        container.querySelector(".cc--dialog-save-button").innerText = this._options.labels.saveButton;
        container.querySelector(".cc--dialog-save-button").addEventListener("click", function (e) {
          e.preventDefault();
          var consentItems = {};

          for (var category in checkByCategory) {
            consentItems[category] = checkByCategory[category].checked ? _this._acceptedState : _this.deniedState;
          }

          var _iterator3 = _createForOfIteratorHelper(_this._listeners),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var l = _step3.value;
              if (l.onSave) l.onSave(consentItems);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          _this.hide();
        }, false);
        document.body.appendChild(container);
        this._showingContainer = container;
      }
    }, {
      key: "hide",
      value: function hide() {
        if (this._showingContainer) {
          document.body.removeChild(this._showingContainer);
          this._showingContainer = null;
        }
      }
    }]);

    return Dialog;
  }();

export { Banner, Dialog, Store };
